import { getRequest } from '@/core';
import { tripAddresses } from '@/requests';

export default async function getTerminalsRequest() {
	let url = tripAddresses.getTerminalsPath();
	return getRequest(url);
}